import { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Camera, Image as ImageIcon, Loader2, X } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const ACCEPT = ".pdf,.docx,.xlsx,.txt,.csv,image/jpeg,image/png,image/webp,image/heic,image/heif";
const MAX = 5;

export function ReferenceUpload({ refs, setRefs, testid = "ai-ref" }) {
  const { t } = useLang();
  const file = useRef();
  const cam = useRef();
  const gal = useRef();
  const [busy, setBusy] = useState(false);
  const up = async (files) => {
    const list = Array.from(files || []).slice(0, MAX - refs.length);
    if (!list.length) return;
    setBusy(true);
    const added = [];
    for (const f of list) {
      const fd = new FormData();
      fd.append("file", f);
      try { added.push((await api.post("/ai/references", fd)).data); } catch (e) { toast.error(`${f.name}: ${errMsg(e)}`); }
    }
    setRefs([...refs, ...added]);
    if (added.length) toast.success(t(`${added.length} file(s) attached (originals are not changed)`, `${added.length} archivo(s) adjuntado(s) (los originales no se modifican)`));
    setBusy(false);
    [file, cam, gal].forEach((r) => { if (r.current) r.current.value = ""; });
  };
  const full = busy || refs.length >= MAX;
  const btn = (ref, Icon, l, id) => <button type="button" className="btn-outline btn-sm" disabled={full} onClick={() => ref.current.click()} data-testid={`${testid}-${id}`}>{busy && id === "upload-btn" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Icon className="w-4 h-4" />} {l}</button>;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input ref={file} type="file" accept={ACCEPT} multiple hidden onChange={(e) => up(e.target.files)} data-testid={`${testid}-file`} />
      <input ref={cam} type="file" accept="image/*" capture="environment" hidden onChange={(e) => up(e.target.files)} data-testid={`${testid}-camera-input`} />
      <input ref={gal} type="file" accept="image/*" multiple hidden onChange={(e) => up(e.target.files)} data-testid={`${testid}-gallery-input`} />
      {btn(file, Paperclip, t("File", "Archivo"), "upload-btn")}
      {btn(cam, Camera, t("Camera", "Cámara"), "camera-btn")}
      {btn(gal, ImageIcon, t("Gallery", "Galería"), "gallery-btn")}
      {refs.map((r) => (
        <span key={r.id} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold max-w-[220px]" data-testid={`${testid}-chip-${r.id}`}>
          <span className="truncate">{r.name}</span>
          <button type="button" onClick={() => setRefs(refs.filter((x) => x.id !== r.id))} aria-label="remove" data-testid={`${testid}-remove-${r.id}`}><X className="w-3 h-3" /></button>
        </span>
      ))}
    </div>
  );
}
